(function () {
  const TOP_THRESHOLD = 400;
  const root = document.querySelector('.floating-actions');
  if (!root) return;

  const topBtn = root.querySelector('[data-action="back-to-top"]');

  let ticking = false;
  function syncTopButton() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      const hidden = window.scrollY < TOP_THRESHOLD;
      root.dataset.topHidden = hidden ? 'true' : 'false';
      ticking = false;
    });
  }
  window.addEventListener('scroll', syncTopButton, { passive: true });
  syncTopButton();

  if (topBtn) {
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
